var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsGr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_560_1752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0013 2.64624C4.66797 2.64624 1.8213 4.71957 0.667969 7.64624C1.8213 10.5729 4.66797 12.6462 8.0013 12.6462C11.3346 12.6462 14.1813 10.5729 15.3346 7.64624C14.1813 4.71957 11.3346 2.64624 8.0013 2.64624ZM8.0013 10.9796C6.1613 10.9796 4.66797 9.48624 4.66797 7.64624C4.66797 5.80624 6.1613 4.31291 8.0013 4.31291C9.8413 4.31291 11.3346 5.80624 11.3346 7.64624C11.3346 9.48624 9.8413 10.9796 8.0013 10.9796ZM8.0013 5.64624C6.89464 5.64624 6.0013 6.53957 6.0013 7.64624C6.0013 8.75291 6.89464 9.64624 8.0013 9.64624C9.10797 9.64624 10.0013 8.75291 10.0013 7.64624C10.0013 6.53957 9.10797 5.64624 8.0013 5.64624Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_560_1752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsGr);
export default __webpack_public_path__ + "static/media/newsGr.1ae5e8f2d71c5473fbb07012c89f1274.svg";
export { ForwardRef as ReactComponent };